module.exports = __webpack_public_path__ + "media/svg/earth-c161ca37.svg";